import Button from '@/componentsv2/Button';
import Dialog from '@/componentsv2/Dialog';

export interface SimpleConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  submitting?: boolean;
  error?: string | null;
}

/**
 * Lightweight confirm modal for the positive lifecycle transitions
 * (Submit/Resume/Reopen). Uses a primary confirm button (ConfirmDialog forces a
 * destructive one) and shows the inline error without closing on failure.
 */
export function SimpleConfirmModal({
  open,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  submitting,
  error,
}: SimpleConfirmModalProps): JSX.Element {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" disablePortal={false}>
      <div data-testid="er-simple-confirm-modal" className="flex flex-col gap-16 p-24">
        <h2 className="hd-5">{title}</h2>
        <p className="text-on-surface-secondary body-1">{message}</p>
        {error ? <p className="text-red-500 body-2">{error}</p> : null}
        <div className="flex justify-end gap-8">
          <Button variant="tertiary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" loading={submitting} disabled={submitting} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
